import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditTimeTrackingActivityCompilationForm } from '../EditTimeTrackingActivityCompilationForm/EditTimeTrackingActivityCompilationForm';
export type EditTimeTrackingActivityCompilationDialogProps = PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>> & {
  timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
};
export const EditTimeTrackingActivityCompilationDialog: FunctionComponent<EditTimeTrackingActivityCompilationDialogProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let timeTrackingActivityCompilation;
  if ($[2] !== t0) {
    ({
      timeTrackingActivityCompilation,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = timeTrackingActivityCompilation;
  } else {
    remainingProps = $[3];
    timeTrackingActivityCompilation = $[4];
  }
  const {
    t
  } = useTranslation();
  const handlePropertyChanged = useModifyEntityCallback(EntityName.TimeTrackingActivityCompilation);
  let t1;
  if ($[5] !== t) {
    t1 = t("components.timeTrackingActivityCompilation.EditTimeTrackingActivityCompilationDialog.tabTitle");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== handlePropertyChanged || $[8] !== timeTrackingActivityCompilation) {
    t2 = <EditTimeTrackingActivityCompilationForm timeTrackingActivityCompilation={timeTrackingActivityCompilation} onPropertyChanged={handlePropertyChanged} data-testid="EditTimeTrackingActivityCompilationDialog.EditTimeTrackingActivityCompilationForm" />;
    $[7] = handlePropertyChanged;
    $[8] = timeTrackingActivityCompilation;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t2) {
    t3 = <SingleTabEditDialog tabTitle={t1} {...remainingProps}>{t2}</SingleTabEditDialog>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});